<!-- Fills the plugin window: this page is hosted in a fixed-size WebView2, so it is laid out to fit
     rather than to scroll, and the two panels sit side by side as soon as there is room. -->
<div class="flex flex-col gap-4 h-full">
  @if (isLoading()) {
    <div class="flex flex-1 flex-col items-center justify-center gap-3">
      <p-progress-spinner></p-progress-spinner>
      <p class="text-sm text-gray-500 m-0">Loading...</p>
    </div>
  }
  @if (!isLoading()) {
    <div class="grid gap-4 sm:grid-cols-2">

      <section class="rounded-lg border border-gray-200 p-4">
        <h3 class="flex items-center gap-2 text-sm font-semibold text-gray-900 mt-0 mb-3">
          <i class="pi pi-user text-gray-400"></i> Account
        </h3>
        @if (userInfo()) {
          <div class="flex flex-col gap-2">
            <div class="flex items-baseline gap-3">
              <span class="w-28 shrink-0 text-xs text-gray-500">Name</span>
              <span class="text-sm font-medium text-gray-900 truncate">{{ userInfo()!.fullName }}</span>
            </div>
            <div class="flex items-baseline gap-3">
              <span class="w-28 shrink-0 text-xs text-gray-500">Email</span>
              <span class="text-sm font-medium text-gray-900 truncate">{{ userInfo()!.email }}</span>
            </div>
            <div class="flex items-baseline gap-3">
              <span class="w-28 shrink-0 text-xs text-gray-500">Position</span>
              <span class="text-sm font-medium text-gray-900 truncate">{{ userInfo()!.position }}</span>
            </div>
            <div class="flex items-center gap-3">
              <span class="w-28 shrink-0 text-xs text-gray-500">Role</span>
              <p-tag
                [value]="getRoleDisplayName(userInfo()!.role)"
                [severity]="getRoleSeverity(userInfo()!.role)">
              </p-tag>
            </div>
          </div>
        }
      </section>

      <section class="rounded-lg border border-gray-200 p-4">
        <h3 class="flex items-center gap-2 text-sm font-semibold text-gray-900 mt-0 mb-3">
          <i class="pi pi-info-circle text-gray-400"></i> Plugin
        </h3>
        <div class="flex flex-col gap-2">
          <div class="flex items-baseline gap-3">
            <span class="w-28 shrink-0 text-xs text-gray-500">Name</span>
            <span class="text-sm font-medium text-gray-900 truncate">{{ pluginInfo()?.name || 'Anguleris Revit Plugin' }}</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="w-28 shrink-0 text-xs text-gray-500">Installed</span>
            @if (installedVersion()) {
              <p-tag [value]="formatVersion(installedVersion())" severity="success"></p-tag>
            } @else {
              <span class="text-sm text-gray-400">Not running in the plugin</span>
            }
          </div>
          <div class="flex items-center gap-3">
            <span class="w-28 shrink-0 text-xs text-gray-500">Latest release</span>
            @if (pluginInfo()?.version) {
              <p-tag [value]="formatVersion(pluginInfo()!.version)" [severity]="isUpToDate() ? 'success' : 'warn'"></p-tag>
            } @else {
              <span class="text-sm text-gray-400">None published</span>
            }
          </div>
          <div class="flex items-baseline gap-3">
            <span class="w-28 shrink-0 text-xs text-gray-500">Released</span>
            <span class="text-sm text-gray-900">{{ (pluginInfo()?.lastUpdated | date:'mediumDate') || '—' }}</span>
          </div>
          <div class="flex items-center gap-3">
            <span class="w-28 shrink-0 text-xs text-gray-500">Environment</span>
            <span class="text-sm text-gray-900">{{ environment() || 'browser' }}</span>
          </div>
        </div>
      </section>

    </div>

    <div class="flex flex-wrap items-center justify-between gap-2 mt-auto border-t border-gray-200 pt-4">
      <div class="flex flex-wrap gap-2">
        <button pButton id="openReleases" type="button" label="Releases" icon="pi pi-download"
                severity="secondary" (click)="openReleases()"></button>
        @if (canOpenTelemetry()) {
          <button pButton id="openTelemetry" type="button" label="Telemetry" icon="pi pi-chart-line"
                  severity="secondary" (click)="openTelemetry()"></button>
        }
      </div>
      <button pButton id="signOut" type="button" label="Sign Out" icon="pi pi-sign-out"
              severity="danger" [outlined]="true" (click)="logout()"></button>
    </div>
  }
</div>
